const tracker =
  'https://docs.google.com/spreadsheets/d/1w6VDezMSvW-HWgE6r-TosydNi4yeSoMjn76028F6Rp4/edit';

export function FormOnboardingScreen({ onCancel }: { onCancel: () => void }) {
  return (
    <main className="app-main" style={{ padding: 'var(--space-8)', overflow: 'auto' }}>
      <div className="card" style={{ maxWidth: 800, padding: 'var(--space-6)', margin: '0 auto' }}>
        <h1>Client onboarding</h1>
        <ol>
          <li>
            <strong>Sales submits the Google Form.</strong> Collect customer name, company, email,
            account slug, and property management software. The account slug sets the dashboard
            address. The connected form starts workspace, dashboard, and managed email provisioning.
          </li>
          <li>
            <strong>The customer connects their software.</strong> After signing in, open Settings →
            Configuration and enter the PMS credentials.
          </li>
          <li>
            <strong>The customer finishes their settings.</strong> Email and phone are under
            Profile. The vendor list and CSV import are under Payees → Vendors.
          </li>
        </ol>
        <p>
          The customer receives their dashboard address and login by email, with{' '}
          ping@eliterealestatenetwork.ca copied, once infrastructure is live and managed email
          delivery checks pass.
        </p>
        <p>
          Open a client’s Agent model card to enter or replace an AI API key. Keys are saved
          securely and never displayed.
        </p>
        <p>
          Form submissions require the signed onboarding trigger to be installed and enabled. Adding
          or editing tracker rows does not provision a client.
        </p>
        <div style={{ display: 'flex', gap: 'var(--space-3)' }}>
          <a className="btn-primary" href={tracker} target="_blank" rel="noreferrer">
            Open onboarding tracker
          </a>
          <button type="button" className="btn-secondary" onClick={onCancel}>
            Back to clients
          </button>
        </div>
      </div>
    </main>
  );
}
